import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid,
  Chip, Box, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Collapse, Tooltip, Dialog,
  DialogTitle, DialogContent, DialogActions, LinearProgress, Alert
} from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import Pagination from '@mui/material/Pagination'
import * as calledsActions from '../../redux/actions/calleds'
import Footer from '../../components/footer'
import moment from "moment"
import { injectIntl } from 'react-intl'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import SpeedIcon from '@mui/icons-material/Speed'
import PeopleIcon from '@mui/icons-material/People'
import AssignmentIcon from '@mui/icons-material/Assignment'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import VisibilityIcon from '@mui/icons-material/Visibility'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import * as ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { PapiroConsole } from "../../utils/papiroConsole"

const STRATEGY_LABELS = {
  'LEAST_LOAD': 'Menor Carga',
  'ROUND_ROBIN': 'Rodízio',
  'WEIGHTED_ROUND_ROBIN': 'Rodízio Ponderado',
  'SKILL_BASED': 'Baseado em Skill'
}

const ENTITY_TYPE_OPTIONS = [
  { id: 'CALLED', name: 'Chamado' },
  { id: 'CHAT', name: 'Chat' }
]

const SUCCESS_OPTIONS = [
  { id: 'true', name: 'Sucesso' },
  { id: 'false', name: 'Falha' }
]


const formatProcessingTime = (ms) => {
  if (ms == null || isNaN(ms)) return '-'
  if (ms < 1000) return `${Math.round(ms)}ms`
  const totalSeconds = ms / 1000
  if (totalSeconds < 60) return `${totalSeconds.toFixed(1)}s`
  const totalMinutes = Math.floor(totalSeconds / 60)
  const secs = Math.floor(totalSeconds % 60)
  if (totalMinutes < 60) return `${totalMinutes}m ${String(secs).padStart(2, '0')}s`
  const totalHours = Math.floor(totalMinutes / 60)
  const mins = totalMinutes % 60
  if (totalHours < 24) return `${totalHours}h ${String(mins).padStart(2, '0')}m ${String(secs).padStart(2, '0')}s`
  const days = Math.floor(totalHours / 24)
  const hours = totalHours % 24
  return `${days}d ${String(hours).padStart(2, '0')}h ${String(mins).padStart(2, '0')}m`
}

// --- Styles ---
const kpiCardStyle = {
  minHeight: 130,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 12,
  position: 'relative',
  overflow: 'hidden',
  transition: 'box-shadow 0.3s ease',
  cursor: 'default',
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0'
}

const kpiIconStyle = {
  fontSize: 40,
  opacity: 0.15,
  position: 'absolute',
  right: 16,
  top: 16,
  color: '#3F51B4'
}

const kpiValueStyle = {
  fontSize: 32,
  fontWeight: 700,
  lineHeight: 1.2,
  color: '#3F51B4'
}

const kpiLabelStyle = {
  fontSize: 13,
  fontWeight: 500,
  marginTop: 4,
  color: '#616161'
}

const tableHeaderStyle = {
  backgroundColor: '#3F51B4',
  '& th': {
    color: '#fff',
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap'
  }
}

class DistributionReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      entityTypeFilter: 0,
      strategyFilter: 0,
      successFilter: 0,
      assignedUserFilter: 0,
      techinicalTeamFilter: 0,
      organizationFilter: 0,
      channelFilter: 0,
      selectedStrategyComments: '',

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      // Main data
      distributionList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      // KPI summary
      summary: null,

      // Breakdown data
      byStrategy: [],
      byAgent: [],

      // Dropdown options
      organizationList: [],
      techinicalTeamList: [],
      channelList: [],
      strategyList: [],

      // Detail dialog
      detailOpen: false,
      detailItem: null,

      // Expanded rows
      expandedRows: {}
    }

    this.changeValues = this.changeValues.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await Promise.all([
      this.getOrganizations(),
      this.getTechinicalTeams(),
      this.getChannels(),
      this.getDistributionStrategies()
    ])
    this.setState({ loading: false })
  }

  getOrganizations = async () => {
    await Api.get('/organizations/list')
      .then(result => {
        if (result.data.success)
          this.setState({ organizationList: result.data.data })
      })
      .catch(() => {})
  }

  getTechinicalTeams = async () => {
    await Api.get('/techinicalteams/list')
      .then(result => {
        if (result.data.success)
          this.setState({ techinicalTeamList: result.data.data })
      })
      .catch(() => {})
  }

  getChannels = async () => {
    await Api.get('/channels')
      .then(result => {
        if (result.data.success)
          this.setState({ channelList: result.data.data })
      })
      .catch(() => {})
  }

  getDistributionStrategies = async () => {
    await Api.get('/distributionstrategies')
      .then(result => {
        if (result.data.success) {
          const strategies = result.data.data.map(s => ({
            id: s.code,
            name: s.name,
            comments: s.comments
          }))
          this.setState({ strategyList: strategies })
        }
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (stateName === 'strategyFilter') {
      if (value && value.id !== undefined) {
        const selected = this.state.strategyList.find(s => s.id === value.id)
        this.setState({ strategyFilter: value.id, selectedStrategyComments: selected ? selected.comments : '' })
      } else {
        this.setState({ strategyFilter: value, selectedStrategyComments: '' })
      }
    } else if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  formatStrategyName = (code) => {
    const friendlyLabel = STRATEGY_LABELS[code] || code || '-'
    const dbStrategy = this.state.strategyList.find(s => s.id === code)
    if (dbStrategy && dbStrategy.name && dbStrategy.name !== friendlyLabel) {
      return `${friendlyLabel} (${dbStrategy.name})`
    }
    return friendlyLabel
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  fetchReport = async () => {
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await Promise.all([
      this.fetchPaginate(dateStart, dateEnd, 1),
      this.fetchSummary(dateStart, dateEnd),
      this.fetchByStrategy(dateStart, dateEnd),
      this.fetchByAgent(dateStart, dateEnd)
    ])

    this.setState({ showGrid: true, loading: false })
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`
    if (this.state.entityTypeFilter && this.state.entityTypeFilter !== 0)
      params += `&entityType=${this.state.entityTypeFilter}`
    if (this.state.strategyFilter && this.state.strategyFilter !== 0)
      params += `&strategyCode=${this.state.strategyFilter}`
    if (this.state.successFilter && this.state.successFilter !== 0)
      params += `&isSuccess=${this.state.successFilter}`
    if (this.state.assignedUserFilter && this.state.assignedUserFilter !== 0)
      params += `&assignedUserId=${this.state.assignedUserFilter}`
    if (this.state.techinicalTeamFilter && this.state.techinicalTeamFilter !== 0)
      params += `&techinicalTeamId=${this.state.techinicalTeamFilter}`
    if (this.state.organizationFilter && this.state.organizationFilter !== 0)
      params += `&organizationId=${this.state.organizationFilter}`
    if (this.state.channelFilter && this.state.channelFilter !== 0)
      params += `&channelId=${this.state.channelFilter}`
    return params
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/distribution/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            distributionList: result.data.data,
            count: result.data.count,
            page: page
          })
          this.setPagination(result.data.count, page)
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : "Erro ao buscar dados de distribuição."
        })
      })
  }

  fetchSummary = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/distribution/summary?${params}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ summary: result.data.data })
        }
      })
      .catch(() => {})
  }

  fetchByStrategy = async (dateStart, dateEnd) => {
    await ApiReports.get(`/report/distribution/by-strategy?startDate=${dateStart}&endDate=${dateEnd}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ byStrategy: result.data.data })
        }
      })
      .catch(() => {})
  }

  fetchByAgent = async (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`
    if (this.state.techinicalTeamFilter && this.state.techinicalTeamFilter !== 0)
      params += `&techinicalTeamId=${this.state.techinicalTeamFilter}`
    if (this.state.organizationFilter && this.state.organizationFilter !== 0)
      params += `&organizationId=${this.state.organizationFilter}`
    await ApiReports.get(`/report/distribution/by-agent?${params}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ byAgent: result.data.data })
        }
      })
      .catch(() => {})
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart: pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 })
    }
  }

  toggleRow = (id) => {
    this.setState(prev => ({
      expandedRows: { ...prev.expandedRows, [id]: !prev.expandedRows[id] }
    }))
  }

  openDetail = (item) => {
    this.setState({ detailOpen: true, detailItem: item })
  }

  closeDetail = () => {
    this.setState({ detailOpen: false, detailItem: null })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const wb = new ExcelJS.Workbook()
      wb.creator = 'Mexx2DO'
      wb.created = new Date()

      // --- Sheet 1: Log Detalhado ---
      const ws1 = wb.addWorksheet('Distribuições')
      ws1.columns = [
        { header: 'ID', key: 'id', width: 10 },
        { header: 'Data', key: 'distributedAt', width: 20 },
        { header: 'Tipo', key: 'entityType', width: 12 },
        { header: 'ID Entidade', key: 'entityId', width: 12 },
        { header: 'Estratégia', key: 'strategyCode', width: 22 },
        { header: 'Agente Atribuído', key: 'assignedUserName', width: 25 },
        { header: 'Motivo Seleção', key: 'selectionReason', width: 25 },
        { header: 'Detalhe Seleção', key: 'selectionDetail', width: 45 },
        { header: 'Elegíveis', key: 'eligibleAgentsCount', width: 12 },
        { header: 'Sucesso', key: 'isSuccess', width: 10 },
        { header: 'Motivo Falha', key: 'failureReason', width: 30 },
        { header: 'Tempo (ms)', key: 'processingTimeMs', width: 12 },
        { header: 'Organização', key: 'organizationName', width: 25 },
        { header: 'Time', key: 'techinicalTeamName', width: 25 },
        { header: 'Categoria', key: 'organizationCategoryName', width: 25 },
        { header: 'Trigger', key: 'triggerReason', width: 20 }
      ]

      // Style header
      ws1.getRow(1).eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3F51B4' } }
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, size: 11 }
        cell.alignment = { horizontal: 'center', vertical: 'middle' }
        cell.border = {
          bottom: { style: 'thin', color: { argb: 'FF444444' } }
        }
      })
      ws1.getRow(1).height = 28

      this.state.distributionList.forEach(item => {
        ws1.addRow({
          id: item.id,
          distributedAt: moment(item.distributedat).format('DD/MM/YYYY HH:mm:ss'),
          entityType: item.entitytype === 'CALLED' ? 'Chamado' : 'Chat',
          entityId: item.entityid,
          strategyCode: this.formatStrategyName(item.strategycode),
          assignedUserName: item.assignedusername || '-',
          selectionReason: item.selectionreason || '-',
          selectionDetail: item.selectiondetail || '-',
          eligibleAgentsCount: item.eligibleagentscount,
          isSuccess: item.issuccess ? 'Sim' : 'Não',
          failureReason: item.failurereason || '-',
          processingTimeMs: item.processingtimems || 0,
          organizationName: item.organizationname || '-',
          techinicalTeamName: item.techinicalteamname || '-',
          organizationCategoryName: item.organizationcategoryname || '-',
          triggerReason: item.triggerreason || '-'
        })
      })

      // Alternate row colors
      ws1.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          const fill = rowNumber % 2 === 0
            ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8F9FA' } }
            : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
          row.eachCell(cell => { cell.fill = fill })
        }
      })

      // --- Sheet 2: Por Agente ---
      if (this.state.byAgent.length > 0) {
        const ws2 = wb.addWorksheet('Por Agente')
        ws2.columns = [
          { header: 'Agente', key: 'assignedUserName', width: 30 },
          { header: 'Total Recebido', key: 'totalReceived', width: 15 },
          { header: 'Chamados', key: 'calledCount', width: 12 },
          { header: 'Chats', key: 'chatCount', width: 12 },
          { header: 'Tempo Médio (ms)', key: 'avgProcessingTimeMs', width: 18 }
        ]
        ws2.getRow(1).eachCell(cell => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3F51B4' } }
          cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, size: 11 }
          cell.alignment = { horizontal: 'center', vertical: 'middle' }
        })
        ws2.getRow(1).height = 28
        this.state.byAgent.forEach(item => {
          ws2.addRow({
            assignedUserName: item.assignedusername,
            totalReceived: item.totalreceived,
            calledCount: item.calledcount,
            chatCount: item.chatcount,
            avgProcessingTimeMs: item.avgprocessingtimems
          })
        })
      }

      // --- Sheet 3: Por Estrategia ---
      if (this.state.byStrategy.length > 0) {
        const ws3 = wb.addWorksheet('Por Estratégia')
        ws3.columns = [
          { header: 'Estratégia', key: 'strategyCode', width: 25 },
          { header: 'Total', key: 'count', width: 12 },
          { header: 'Sucesso', key: 'successCount', width: 12 },
          { header: 'Falha', key: 'failureCount', width: 12 },
          { header: 'Tempo Médio (ms)', key: 'avgProcessingTimeMs', width: 18 }
        ]
        ws3.getRow(1).eachCell(cell => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3F51B4' } }
          cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, size: 11 }
          cell.alignment = { horizontal: 'center', vertical: 'middle' }
        })
        ws3.getRow(1).height = 28
        this.state.byStrategy.forEach(item => {
          ws3.addRow({
            strategyCode: this.formatStrategyName(item.strategycode),
            count: item.count,
            successCount: item.successcount,
            failureCount: item.failurecount,
            avgProcessingTimeMs: item.avgprocessingtimems
          })
        })
      }

      const buffer = await wb.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      saveAs(blob, `relatorio_distribuicao_${moment(this.state.dateStart).format('YYYY-MM-DD')}_${moment(this.state.dateEnd).format('YYYY-MM-DD')}.xlsx`)
    } catch (e) {
      PapiroConsole.log(e)
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "Erro ao gerar arquivo Excel."
      })
    }
    this.setState({ loading: false })
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  parseEligibleAgents = (snapshot) => {
    if (!snapshot) return []
    try {
      return JSON.parse(snapshot)
    } catch {
      return []
    }
  }

  renderKPIs() {
    const { summary } = this.state
    if (!summary) return null

    const successRateColor = summary.successrate >= 90 ? '#059669' : summary.successrate >= 70 ? '#d97706' : '#dc2626'

    const cards = [
      {
        label: 'Total Distribuições',
        value: summary.totaldistributions,
        icon: <AssignmentIcon style={kpiIconStyle} />,
        tooltip: 'Quantidade total de distribuições automáticas realizadas no período selecionado, independente de sucesso ou falha.'
      },
      {
        label: 'Taxa de Sucesso',
        value: `${summary.successrate}%`,
        valueColor: successRateColor,
        icon: <TrendingUpIcon style={kpiIconStyle} />,
        tooltip: 'Percentual de distribuições que foram concluídas com sucesso. Calculada como: (distribuições com sucesso ÷ total de distribuições) × 100. Verde (≥90%): excelente. Amarelo (70%-89%): atenção. Vermelho (<70%): crítico.'
      },
      {
        label: 'Sucesso / Falha',
        value: `${summary.successcount} / ${summary.failurecount}`,
        icon: <CheckCircleIcon style={kpiIconStyle} />,
        tooltip: 'Quantidade absoluta de distribuições com sucesso e com falha no período. Sucesso = agente atribuído com êxito. Falha = nenhum agente elegível encontrado ou erro no processo.'
      },
      {
        label: 'Tempo Médio',
        value: formatProcessingTime(summary.avgprocessingtimems),
        icon: <SpeedIcon style={kpiIconStyle} />,
        tooltip: 'Tempo médio de processamento de cada distribuição, desde o início da busca por agentes elegíveis até a atribuição final. Calculado como a média aritmética do tempo de todas as distribuições no período. Valores baixos indicam boa performance do algoritmo de distribuição.'
      },
      {
        label: 'Média Elegíveis',
        value: summary.avgeligibleagents,
        icon: <PeopleIcon style={kpiIconStyle} />,
        tooltip: 'Quantidade média de agentes que estavam elegíveis (disponíveis e dentro dos critérios) no momento de cada distribuição. Valores muito baixos podem indicar falta de agentes disponíveis ou filtros muito restritivos na estratégia de distribuição.'
      }
    ]

    return (
      <Grid container spacing={2} style={{ marginBottom: 20, marginTop: 10 }}>
        {cards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={true} key={idx}>
            <Tooltip title={card.tooltip} arrow placement="top">
              <Paper elevation={1} style={kpiCardStyle}>
                {card.icon}
                <Typography style={{ ...kpiValueStyle, ...(card.valueColor ? { color: card.valueColor } : {}) }}>{card.value}</Typography>
                <Typography style={kpiLabelStyle}>{card.label}</Typography>
              </Paper>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    )
  }

  renderStrategyBreakdown() {
    const { byStrategy } = this.state
    if (!byStrategy || byStrategy.length === 0) return null

    const total = byStrategy.reduce((sum, s) => sum + s.count, 0)

    return (
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden' }}>
            <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
                Distribuição por Estratégia
              </Typography>
            </Box>
            <Box style={{ padding: 20 }}>
              {byStrategy.map((item, idx) => {
                const pct = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0
                const successPct = item.count > 0 ? ((item.successcount / item.count) * 100).toFixed(1) : 0
                return (
                  <Box key={idx} style={{ marginBottom: idx < byStrategy.length - 1 ? 16 : 0 }}>
                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                        {this.formatStrategyName(item.strategycode)}
                      </Typography>
                      <Box style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        <Chip size="small" label={`${item.count} (${pct}%)`} style={{ fontWeight: 600 }} />
                        <Chip size="small" label={`Sucesso: ${successPct}%`}
                          style={{
                            backgroundColor: successPct >= 90 ? '#dcfce7' : successPct >= 70 ? '#fef3c7' : '#fecaca',
                            color: successPct >= 90 ? '#166534' : successPct >= 70 ? '#92400e' : '#991b1b',
                            fontWeight: 600
                          }} />
                        <Typography variant="caption" style={{ color: '#666' }}>
                          ~{item.avgprocessingtimems}ms
                        </Typography>
                      </Box>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={parseFloat(pct)}
                      style={{ height: 8, borderRadius: 4, backgroundColor: '#e5e7eb' }}
                      sx={{ '& .MuiLinearProgress-bar': { borderRadius: 4, backgroundColor: '#66BB6A' } }}
                    />
                  </Box>
                )
              })}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    )
  }

  renderAgentRanking() {
    const { byAgent } = this.state
    if (!byAgent || byAgent.length === 0) return null

    const maxReceived = Math.max(...byAgent.map(a => a.totalreceived), 1)

    return (
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden' }}>
            <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
                Ranking de Agentes
              </Typography>
            </Box>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow style={{ backgroundColor: '#3F51B4' }}>
                    <TableCell style={{ fontWeight: 700, width: 50, color: '#fff' }}>#</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff' }}>Agente</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Total</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Chamados</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Chats</TableCell>
                    <TableCell style={{ fontWeight: 700, minWidth: 200, color: '#fff' }}>Proporção</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Tempo Médio</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {byAgent.map((agent, idx) => {
                    const pct = ((agent.totalreceived / maxReceived) * 100).toFixed(0)
                    return (
                      <TableRow key={idx} hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                        <TableCell>
                          <Box style={{
                            width: 28, height: 28, borderRadius: '50%',
                            backgroundColor: idx < 3 ? '#3F51B4' : '#94a3b8',
                            color: '#fff', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontWeight: 700, fontSize: 12
                          }}>
                            {idx + 1}
                          </Box>
                        </TableCell>
                        <TableCell style={{ fontWeight: 500 }}>{agent.assignedusername}</TableCell>
                        <TableCell align="center" style={{ fontWeight: 700, fontSize: 16 }}>{agent.totalreceived}</TableCell>
                        <TableCell align="center">
                          <Chip size="small" label={agent.calledcount}
                            style={{ backgroundColor: '#dbeafe', color: '#1e40af', fontWeight: 600 }} />
                        </TableCell>
                        <TableCell align="center">
                          <Chip size="small" label={agent.chatcount}
                            style={{ backgroundColor: '#d1fae5', color: '#065f46', fontWeight: 600 }} />
                        </TableCell>
                        <TableCell>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Box style={{ flex: 1, height: 8, borderRadius: 4, backgroundColor: '#e5e7eb', overflow: 'hidden' }}>
                              <Box style={{ width: `${pct}%`, height: '100%', borderRadius: 4, backgroundColor: '#66BB6A', transition: 'width 0.5s ease' }} />
                            </Box>
                            <Typography variant="caption" style={{ fontWeight: 600, minWidth: 35 }}>{pct}%</Typography>
                          </Box>
                        </TableCell>
                        <TableCell align="center" style={{ color: '#666' }}>{agent.avgprocessingtimems}ms</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    )
  }

  renderDetailDialog() {
    const { detailOpen, detailItem } = this.state
    if (!detailItem) return null

    const agents = this.parseEligibleAgents(detailItem.eligibleagentssnapshot)

    return (
      <Dialog open={detailOpen} onClose={this.closeDetail} maxWidth="md" fullWidth>
        <DialogTitle style={{ backgroundColor: '#3F51B4', color: '#fff', fontWeight: 600 }}>
          Detalhe da Distribuição #{detailItem.id}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Tipo</Typography>
              <Typography style={{ fontWeight: 600 }}>{detailItem.entitytype === 'CALLED' ? 'Chamado' : 'Chat'}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">ID Entidade</Typography>
              <Typography style={{ fontWeight: 600 }}>#{detailItem.entityid}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Estratégia</Typography>
              <Typography style={{ fontWeight: 600 }}>{this.formatStrategyName(detailItem.strategycode)}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Status</Typography>
              {detailItem.issuccess
                ? <Chip size="small" icon={<CheckCircleIcon />} label="Sucesso" style={{ backgroundColor: '#dcfce7', color: '#166534' }} />
                : <Chip size="small" icon={<CancelIcon />} label="Falha" style={{ backgroundColor: '#fecaca', color: '#991b1b' }} />
              }
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Organização</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.organizationname || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Time</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.techinicalteamname || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Categoria</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.organizationcategoryname || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Tempo</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.processingtimems}ms</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary">Agente Atribuído</Typography>
              <Typography style={{ fontWeight: 600, fontSize: 16 }}>{detailItem.assignedusername || '-'}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary">Motivo da Seleção</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.selectionreason || '-'}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary">Detalhe da Seleção</Typography>
              <Typography style={{ fontWeight: 500, whiteSpace: 'pre-wrap', backgroundColor: '#f8fafc', padding: 12, borderRadius: 8, fontSize: 13 }}>
                {detailItem.selectiondetail || '-'}
              </Typography>
            </Grid>
            {detailItem.failurereason && (
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Motivo da Falha</Typography>
                <Typography style={{ fontWeight: 500, color: '#dc2626' }}>{detailItem.failurereason}</Typography>
              </Grid>
            )}
          </Grid>

          {agents.length > 0 && (
            <Box style={{ marginTop: 20, maxWidth: '100%', overflow: 'hidden' }}>
              <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 10 }}>
                Snapshot de Agentes Elegíveis ({agents.length})
              </Typography>
              <Box sx={{ overflowX: 'auto', maxWidth: '100%', border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Table size="small" style={{ minWidth: 900 }}>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#3F51B4' }}>
                      <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Agente</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Time</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Chamados Abertos</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Chats Abertos</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Max Chamados</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Max Chats</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Peso</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Proficiência</TableCell>
                      <TableCell align="center" style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Skill</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {agents.map((ag, idx) => (
                      <TableRow key={idx} hover style={{
                        backgroundColor: ag.userId === detailItem.assigneduserid ? '#dbeafe' : (idx % 2 === 0 ? '#fff' : '#f8fafc')
                      }}>
                        <TableCell style={{ fontWeight: ag.userId === detailItem.assigneduserid ? 700 : 400, whiteSpace: 'nowrap' }}>
                          {ag.userName}
                          {ag.userId === detailItem.assigneduserid && (
                            <Chip size="small" label="Sel." style={{ marginLeft: 6, backgroundColor: '#059669', color: '#fff', fontSize: 9, height: 20 }} />
                          )}
                        </TableCell>
                        <TableCell align="center">{ag.teamId || '-'}</TableCell>
                        <TableCell align="center">{ag.openCalleds}</TableCell>
                        <TableCell align="center">{ag.openChats}</TableCell>
                        <TableCell align="center">{ag.maxCalleds}</TableCell>
                        <TableCell align="center">{ag.maxChats}</TableCell>
                        <TableCell align="center">{ag.weight || '-'}</TableCell>
                        <TableCell align="center">{ag.proficiency || '-'}</TableCell>
                        <TableCell align="center">
                          {ag.hasSkill
                            ? <CheckCircleIcon style={{ color: '#059669', fontSize: 18 }} />
                            : <CancelIcon style={{ color: '#dc2626', fontSize: 18 }} />
                          }
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDetail} variant="contained" style={{ backgroundColor: '#3F51B4', color: '#fff' }}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderMainTable() {
    const { distributionList } = this.state

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            Log de Distribuições
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.count} registro(s)
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, width: 30, color: '#fff' }} />
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Data</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Tipo</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>ID</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Estratégia</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Agente</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Elegíveis</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Status</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Tempo</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {distributionList.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <TableRow hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                    <TableCell>
                      <IconButton size="small" onClick={() => this.toggleRow(item.id)}>
                        {this.state.expandedRows[item.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {moment(item.distributedat).format('DD/MM/YYYY HH:mm:ss')}
                    </TableCell>
                    <TableCell>
                      <Chip size="small" label={item.entitytype === 'CALLED' ? 'Chamado' : 'Chat'}
                        style={{
                          backgroundColor: item.entitytype === 'CALLED' ? '#dbeafe' : '#d1fae5',
                          color: item.entitytype === 'CALLED' ? '#1e40af' : '#065f46',
                          fontWeight: 600
                        }} />
                    </TableCell>
                    <TableCell style={{ fontWeight: 500 }}>#{item.entityid}</TableCell>
                    <TableCell>
                      <Chip size="small"
                        label={this.formatStrategyName(item.strategycode)}
                        variant="outlined" style={{ fontWeight: 500 }} />
                    </TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{item.assignedusername || '-'}</TableCell>
                    <TableCell align="center">
                      <Box style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 32, height: 32, borderRadius: '50%',
                        backgroundColor: item.eligibleagentscount > 0 ? '#eff6ff' : '#fef2f2',
                        fontWeight: 700, fontSize: 14,
                        color: item.eligibleagentscount > 0 ? '#1e40af' : '#991b1b'
                      }}>
                        {item.eligibleagentscount}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      {item.issuccess
                        ? <Chip size="small" icon={<CheckCircleIcon style={{ fontSize: 16 }} />} label="OK"
                            style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600 }} />
                        : <Chip size="small" icon={<CancelIcon style={{ fontSize: 16 }} />} label="Falha"
                            style={{ backgroundColor: '#fecaca', color: '#991b1b', fontWeight: 600 }} />
                      }
                    </TableCell>
                    <TableCell align="center" style={{ color: '#666', whiteSpace: 'nowrap' }}>
                      {item.processingtimems != null ? `${item.processingtimems}ms` : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Ver detalhes completos">
                        <IconButton size="small" onClick={() => this.openDetail(item)}>
                          <VisibilityIcon style={{ fontSize: 20, color: '#059669' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: this.state.expandedRows[item.id] ? undefined : 'none' }} colSpan={10}>
                      <Collapse in={this.state.expandedRows[item.id]} timeout="auto" unmountOnExit>
                        <Box style={{ margin: '12px 0', padding: 16, backgroundColor: '#f8fafc', borderRadius: 8 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Motivo da Seleção</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.selectionreason || '-'}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Organização / Time</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.organizationname || '-'} / {item.techinicalteamname || '-'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Detalhe</Typography>
                              <Typography style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{item.selectiondetail || '-'}</Typography>
                            </Grid>
                            {item.failurereason && (
                              <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Motivo da Falha</Typography>
                                <Typography style={{ fontSize: 13, color: '#dc2626' }}>{item.failurereason}</Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
              {distributionList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhuma distribuição encontrada para o período selecionado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (Api == null) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Distribuição Automática
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='distributionReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker label="Data Inicial" name='dateStart' stateName='dateStart'
                        changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker label="Data Final" name='dateEnd' stateName='dateEnd'
                        changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Tipo" options={ENTITY_TYPE_OPTIONS}
                        stateName='entityTypeFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Estratégia" options={this.state.strategyList}
                        stateName='strategyFilter' changeSelect={this.changeValues} />
                      {this.state.selectedStrategyComments && (
                        <Alert
                          severity="info"
                          icon={<InfoOutlinedIcon fontSize="inherit" />}
                          sx={{
                            mt: 1,
                            backgroundColor: '#e3f2fd',
                            '& .MuiAlert-icon': { color: '#1976d2' },
                            '& .MuiAlert-message': { color: '#1565c0' }
                          }}
                        >
                          {this.state.selectedStrategyComments}
                        </Alert>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Resultado" options={SUCCESS_OPTIONS}
                        stateName='successFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Canal" options={this.state.channelList}
                        stateName='channelFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Organização" options={this.state.organizationList}
                        stateName='organizationFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Time Técnico" options={this.state.techinicalTeamList}
                        stateName='techinicalTeamFilter' changeSelect={this.changeValues} />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    Filtrar
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      Exportar Excel
                    </Button>
                  </Grid>
                )}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                {this.renderKPIs()}
                {this.renderStrategyBreakdown()}
                {this.renderAgentRanking()}
                {this.renderMainTable()}

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registro(s)
                  </Grid>
                </Grid>
              </>
            )}

            {this.renderDetailDialog()}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

DistributionReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(DistributionReport)))
